// extracted by mini-css-extract-plugin
export default {"wrapper":"form-wrapper-module__wrapper--qGo","a":"form-wrapper-module__a--B9S","button":"form-wrapper-module__button--xsE"};